import React from 'react';
import { CONFIRMATION_MODAL_HEADER_ID } from '../Transfers.meta';
import { ModalHeader } from '../../../../../../../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalFooter } from '../../../../../../../../../../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../../../../../../../../../../CommonComponents/OPL/Button/Button';
import { Modal } from '../../../../../../../../../../CommonComponents/OPL/Modal/Modal';
import { ModalCloseButton } from '../../../../../../../../../../CommonComponents/OPL/Modal/ModalCloseButton';

interface Props {
  onConfirmation(): void;
  onClose(): void;
  modalHeaderText: string;
  isLoading: boolean;
}

export const ConfirmationModal: React.FC<Props> = ({
  onConfirmation,
  onClose,
  modalHeaderText,
  isLoading,
}) => (
  <Modal isOpen onRequestClose={onClose} aria={{ labelledby: CONFIRMATION_MODAL_HEADER_ID }}>
    <ModalHeader id={CONFIRMATION_MODAL_HEADER_ID}>{modalHeaderText}</ModalHeader>

    <ModalCloseButton onClick={onClose} />

    <ModalFooter>
      <Button variant="subtleInactive" onClick={onClose}>
        Cancel
      </Button>

      <Button
        onClick={() => {
          onConfirmation();
        }}
        ml="8"
        variant="error"
        isLoading={isLoading}
      >
        Confirm
      </Button>
    </ModalFooter>
  </Modal>
);
